import { useState, useRef, useContext } from "react";
import { FaBold, FaItalic } from "react-icons/fa";
// import { Card, CardContent } from "@/components/ui/card";
// import { Button } from "@/components/ui/button";
import { LuImagePlus } from "react-icons/lu";
import { RiFontSize2 } from "react-icons/ri";
import { base_url } from "../url_variables";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../context/UserContext";
import { useCookies } from "react-cookie";
import { TopBar } from "../components/topbar";
import { GridLoader } from "react-spinners";

export default function NewPostPage() {
    const editorRef = useRef(null);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [postData, setPostData] = useState(null);
    const [profilePic, setProfilePic] = useState(null);
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [fontSize, setFontSize] = useState(3); // 1–7 (default = 3)

    const increaseFontSize = () => {
    const newSize = Math.min(fontSize + 1, 7);
    setFontSize(newSize);
    exec("fontSize", newSize);
    };

    const decreaseFontSize = () => {
    const newSize = Math.max(fontSize - 1, 1);
    setFontSize(newSize);
    exec("fontSize", newSize);
    };

  const exec = (command, value = null) => {
    editorRef.current?.focus();
    document.execCommand(command, false, value);
    setContent(editorRef.current.innerHTML);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePic(file);
    }
  };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const imageUrl = await uploadImage(file);
            exec("insertImage", imageUrl);
        } catch (err) {
            alert(err.message);
        }
    };


    const uploadImage = async (file) => {
        const formData = new FormData();
        formData.append("image", file);

        const res = await fetch(base_url + '/upload-image.php', {
            method: "POST",
            body: formData,
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.message || "Image upload failed");
        }

        return data.url; // 👈 this is what gets inserted into editor
    };

  const publishPost = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("content", content);
    formData.append("title", title);
    for (const [key, value] of Object.entries(postData)) {
        formData.append(key, value);
    }
    formData.append('profilePic', profilePic);

    try {
        const response = await axios.post(base_url + '/publish-post.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                memberno: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.status) {
            setLoading(false);
            navigate("/dashboard/home");
        } else {
            setLoading(false);
        }
    } catch (error) {
        setLoading(false);
    }
  };

  const alignText = (command) => {
    exec(command, false, null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
    <div className="flex flex-col">
      {loading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#000080'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#000080] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Publish Post`} />
      <div className="max-w-4xl mx-auto shadow-xl rounded-2xl">
        <div className="p-6 space-y-4">
          <h1 className="text-2xl font-semibold">Create Blog Post</h1>
          <input
            type="text"
            placeholder="Post title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border rounded-lg p-3 text-lg"
          />
          <input
            type="text"
            placeholder="Author"
            value={postData?.author}
            onChange={(e) => setPostData({...postData, author: e.target.value})}
            className="w-full border rounded-lg p-3 text-lg"
          />
          <input
            type="number"
            placeholder="Read Duration (Mins)"
            value={postData?.read}
            onChange={(e) => setPostData({...postData, read: e.target.value})}
            className="w-full border rounded-lg p-3 text-lg"
          />
            <label className="inline-flex">
              <input
                  type="file"
                  id="coverImg"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="hidden"
              />
              <label
                  htmlFor="coverImg"
                  className="inline-flex items-center gap-1 cursor-pointer border rounded px-3 py-1 text-sm"
                  >
                  <LuImagePlus size={16} /> Add Cover Image
              </label>
            </label>
          <div className='w-full flex inline-flex flex-wrap justify-start mt-3 gap-x-1'>
              {profilePic != null && 
                  <>
                      <img
                          src={URL.createObjectURL(profilePic)}
                          alt="Preview"
                          className="w-40 h-40 object-cover rounded"
                      />
                  </>
              }
          </div>
          {/* Toolbar */}
          <div className="flex flex-wrap gap-2 border rounded-lg p-2 bg-white">
            <button size="sm" variant="outline" onClick={() => exec("bold")}>
              <FaBold size={16} />
            </button>
            <button size="sm" variant="outline" onClick={() => exec("italic")}>
              <FaItalic size={16} />
            </button>
            {/* Decrease font size */}
            <button
                type="button"
                onClick={decreaseFontSize}
                className="border rounded px-2 py-1 text-sm"
            >
                A-
            </button>

            {/* Increase font size */}
            <button
                type="button"
                onClick={increaseFontSize}
                className="border rounded px-2 py-1 text-sm"
            >
                A+
            </button>
            
            <div title="Default color" onClick={() => exec("foreColor", '#cc9933')} className="bg-[#cc9933] w-8 h-8 p-0 border rounded cursor-pointer">
            </div>

            {/* Font color */}
            <input
                type="color"
                onChange={(e) => exec("foreColor", e.target.value)}
                className="w-8 h-8 p-0 border rounded cursor-pointer"
                title="Text color"
            />

            <div className="flex gap-x-2">
              <button
                onClick={() => alignText('justifyLeft')}
                className="px-3 py-1 bg-gray-700 text-white rounded"
              >
                Left
              </button>

              <button
                onClick={() => alignText('justifyCenter')}
                className="px-3 py-1 bg-gray-700 text-white rounded"
              >
                Center
              </button>

              <button
                onClick={() => alignText('justifyRight')}
                className="px-3 py-1 bg-gray-700 text-white rounded"
              >
                Right
              </button>

              <button
                onClick={() => alignText('justifyFull')}
                className="px-3 py-1 bg-gray-700 text-white rounded"
              >
                Justify
              </button>
            </div>

            {/* Image upload */}

            <label className="inline-flex">
              <input id="imageUpload" type="file" hidden accept="image/*" onChange={handleImageUpload} />
              <label
                htmlFor="imageUpload"
                className="inline-flex items-center gap-1 cursor-pointer border rounded px-3 py-1 text-sm"
                >
                <LuImagePlus size={16} /> Image
              </label>
            </label>
          </div>

          {/* Editor */}
          <div
            ref={editorRef}
            contentEditable
            className="min-h-[500px] text-white bg-[#172848] border rounded-lg p-4 focus:outline-none"
            placeholder="Write your post content here..."
            onInput={() => setContent(editorRef.current.innerHTML)}
          />

          {/* Preview / Debug */}
          <div className="text-sm text-gray-500">
            <p>HTML Output:</p>
            <pre className="bg-gray-100 p-2 rounded text-xs overflow-x-auto">
              {content}
            </pre>
          </div>

          <button onClick={() => publishPost()} className="w-full bg-blue-600 py-2 text-white">Publish Post</button>
        </div>
      </div>
       </div>
    </div>
  );
}
